import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { ConnectedRouter } from 'connected-react-router'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { Route } from 'react-router-dom'
import ScrollToTop from 'components/ScrollToTop'
import { IntlProvider, addLocaleData } from "react-intl"
import en from 'react-intl/locale-data/en'
import es from 'react-intl/locale-data/es'
import translations from '../translations'
import App from './App'
import ErrorHandler from './Utils/ErrorHandler'

// import 'moment/locale/zh-cn';
// moment.locale('zh-cn');

// import { ConfigProvider } from 'antd'
// import esES from 'antd/es/locale-provider/es_ES'

addLocaleData(en)
addLocaleData(es)


export default class Root extends Component {
  render() {

    let lang

    if (!localStorage.getItem('lang')) {
      lang = 'es'
      localStorage.setItem('lang', 'es')
    } else {
      lang = localStorage.getItem('lang')
    }

    const { store, history, persistor } = this.props
    return (
      <IntlProvider locale={lang} messages={translations(lang)}>
        <Provider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <ConnectedRouter history={history}>
              <ScrollToTop>
                <ErrorHandler>
                  {/* <ConfigProvider locale={esES}> */}
                  <Route path="/" component={App} />
                  {/* </ConfigProvider> */}
                </ErrorHandler>
              </ScrollToTop>
            </ConnectedRouter>
          </PersistGate>
        </Provider>
      </IntlProvider>
    )
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired
}